<template>
  <b-modal id="view-document-detail"
           centered
           hide-footer
           @hidden="onModalHidden"
           size="lg">
    <div>
        <div>
            <!--<div class="page-title">
                <h1>Document View Details</h1>
            </div> -->
            <div class="row body-main-row">
                <div>
                    <b-skeleton-table
                    v-if="skeletonLoader"
                    :rows="15"
                    :columns="1"
                    :table-props="{ bordered: none, striped: true }">
                    </b-skeleton-table>
                    <div class="document-view-body" v-if="!skeletonLoader">
                        <p><img class="elevate-logo" src="@/assets/images/darknuera.png"></p>
                        <div class="directory-block" style="text-align:left">
                            <h2>{{ data.user_info.first_name }}  {{data.user_info.last_name }}</h2>
                            <ul>
                                <li>{{ data.user_info.address1 }}</li>
                                <li>{{ data.user_info.city }}, {{ data.user_info.state }} {{ data.user_info.zip }}</li>
                            </ul>
                        </div>
                        <p v-if="data.is_nawu" style="text-align:right">December 1st , 2023</p>
                        <p v-else style="text-align:right">July 25th, 2025</p>

                        <p style="text-align:left"><strong>Dear Valued Member,</strong></p>
                        <!-- <div v-if="data.is_nawu">
                        <p>As of January 1st 2024 the <strong>{{ data.old_plan_name }}</strong> will renew. Your rate as of January 1st 2024 is listed below. These rates include Association fees, Administrative fees and union dues.
                        <br>
                        The increase for 2024 is 18%. Although the increase is larger than other years the benefits remain the same for 2024, which considering the current health climate is rare as most general plans are removing benefits.
                        <br>
                        Please note the renewal is automatic and no additional paperwork is required.
                        <br>
                        Billing will be adjusted accordingly on your upcoming invoice or Electronic Payment (EFT)
                        </p>

                        </div> -->
                        <div style="text-align:left">
                            <p>As of September 1st, 2025, the <strong>{{ planNames }}</strong> plan will be renewed. There is nothing you need to do on your end as the renewal is automatic. This is just a formal notification of the rate change for Septmeber 2025 - August 2026.</p>
                            <p>Billing will be adjusted accordingly on your upcoming Statement or Electronic Payment (EFT).</p>
                            <br>
                            <p><strong>Your new rate for your benefit plan as of Septmeber 1st, 2025 will be as follows:</strong></p>
                        </div>
                        <div v-if="updatedPlans.length">
                            <div v-for="(plan, index) in updatedPlans" :key="index" class="new-rate-details">
                                <ul >
                                    <li>Plan: <strong>{{ plan.planName }}</strong></li>
                                    <li>Tier: <strong>{{ plan.tierInfo }}</strong></li>
                                    <li>New Rate: <strong>${{ plan.newRate }}</strong></li>
                                </ul>
                            </div>
                        </div>
              <div style="text-align:left">
                <p>This new rate will be effective until the next renewal on August 31st, 2026.</p>
                <p>If you have any questions, you may contact your representative or broker.</p>
                <br>
              </div>

                        <!-- <div class="new-rate-details">
                            <ul>
                                <li>Plan: <strong>{{ data.plan_name }}</strong></li>
                                <li>Tier: <strong>{{ data.tier_info }}</strong></li>
                                <li>New Rate: <strong>${{data.new_rate}}</strong></li>
                            </ul>
                        </div> -->
                        <!-- <div v-if="data.is_nawu">
                        <p>This rate will be good until next renewal.
                            <br>
                            If you have any questions or want to discuss other plan options, please contact your broker.
                        </p>
                        </div> -->
                        <!-- <div v-else>
                        <p class="osf"><em>This new rate will be good until next renewal on <strong>December 31st, 2024.</strong></em></p>
                        <p class="osf"><em>If you have any questions or want to change your plan design and possibly decreasing your rate, you may contact your broker.</em></p>
                        <br>
                        </div> -->
                       <!-- <p style="text-align:left"> <span>Broker: <b>{{ data.agent_name }}</b></span>    <span style="margin-left: 14%;">Phone : <b>{{ data.agent_phone }}</b></span> </p>
                        <br> -->
                        <div class="doc-footer" style="text-align:left">
                            <p><strong>Sincerely,</strong></p>
                            <p class="osf">NuEra Billing Services</p>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
  </b-modal>
</template>
<script>
import axios from 'axios';
/*eslint-disable*/
export default {
  name: 'DocumentViewDetails',
  data: () => ({
    data: [],
    skeletonLoader: true,
    planNames: '',
    updatedPlans: [],
  }),
  props: {
    excludedPlans: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async getData(){
      //let loader = this.$loading.show();
      try {
        // Fetch both APIs concurrently
        const [rateDetailsResponse, policyListResponse] = await Promise.all([
          axios.get('/get-new-rate-details'),
          axios.get('/get-policy-list')
        ]);

        this.data = rateDetailsResponse.data.data;
        this.policyData = policyListResponse.data.data;

            if (Array.isArray(this.data.updated_plans)) {
              this.updatedPlans = this.data.updated_plans.filter(plan => !this.excludedPlans.includes(plan.plan_id));
              this.updatedPlans = this.updatedPlans.map((plan) => {
                const matchingPolicyPlan = this.findMatchingPlan(plan.plan_name);
            
                return {
                        planName: plan.plan_name,
                        tier: plan.tier,
                        tierInfo: plan.tier_info,
                  // Use price from policy list API if found, otherwise fallback to original new_rate
                newRate: matchingPolicyPlan ? matchingPolicyPlan.price : plan.new_rate,
                };
              });
              // Populate planName with all plan names from updatedPlans, separated by commas
              this.planNames = this.updatedPlans.map((plan) => plan.planName).join(" , ");
            }
          }catch (error) {
            console.error('Error fetching data:', error);
            // Handle error appropriately
          }finally {
                this.skeletonLoader = false
                // loader.hide();
              };
    },
    findMatchingPlan(planName) {
      if (!this.policyData || !this.policyData.policy_details) {
        return null;
      }
      
      // Search through all policies and their plans
      for (const policy of this.policyData.policy_details) {
        if (policy.plans) {
          const matchingPlan = policy.plans.find(plan => 
            plan.plan_name === planName && plan.status === 'ACTIVE'
          );
          if (matchingPlan) {
            return matchingPlan;
          }
        }
      }
      return null;
    },
    onModalHidden() {
      // Emit event to parent component when modal is closed
      this.$emit('popup-dismissed');
      
      // Notify parent component through root event bus (alternative method)
      this.$root.$emit('document-popup-dismissed');
    }
    },
    created() {
    this.getData();
  },
}
</script>

<style scoped>
.document-view-body {
    position: relative;
    top: -95px;
    background: transparent;
    box-shadow: none;
    padding: 30px;
    padding-top: 20px;
    margin-top: 20px;
    border-radius: 15px;
}
.document-view-body p {
    font-size: 14px;
    margin-bottom: 10px;
}
.new-rate-details {
    padding: 30px;
    max-width: 800px;
    margin-bottom: 13px;
    background: #f3f7fa;
    border-radius: 10px;
    margin-top: 15px;
}
.document-view-body .osf {
    opacity: 0.7;
    margin-bottom: 5px;
}
.new-rate-details ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
}
.new-rate-details ul li {
    display: inline-block;
}
.new-rate-details strong {
    color: #03c3ec;
}
.doc-footer p {
    margin-bottom: 4px;
}
.doc-footer p:first-child {
    margin-top: 2%;
}
.doc-footer .osf {
    margin-bottom: 2px;
}
.elevate-logo {
    width: 20%;
    display: block;
    margin: 0px auto;
    margin-top:2%
}
.directory-block {
  margin-bottom:3%;
  }
</style>
